let enabledFeatureFlags = [];

export const isFeatureEnabled = flagName => enabledFeatureFlags.includes(flagName);
export const setEnabledFeatureFlags = flags => (enabledFeatureFlags = [...flags]);
